import { libsRegistry } from '@zeainc/zea-engine'

import pkg from '../package.json'
if (libsRegistry) {
  libsRegistry.registerLib(pkg)
} else {
  console.warn(
    "The version of the Zea Engine that you're using doesn't support the libraries registry. Please upgrade to the latest Zea Engine version."
  )
}

export * from './ExplodePartsOperator'
export * from './GearsOperator'

// TODO: Implement test, and reenable export.
// export * from './PistonOperator'
export * from './AimOperator'
export * from './RamAndPistonOperator'
export * from './TriangleIKSolver'
export * from './IKSolver'
export * from './AttachmentConstraint'
export * from './Tracks/index'
